<template>
  <div class="footer-response py-0" :class="{ 'px-4': isFooter }">
    <VueElementLoading :active="isSaving" />

    <BaseInput
      id="response-description"
      v-model="description"
      input-type="textarea"
      label="Your Response"
      placeholder="Enter your response"
      :is-invalid="submitFail"
      invalid-warning-text="Response must be at least 1 character or have at least 1 attachment"
      :class="{ 'mt-4': isFooter }"
      @keyupEnter="submit"
    />

    <div class="d-flex align-items-center justify-content-between">
      <BaseFilesUploadButton
        v-if="!message || message.isFileMessage"
        class="pl-2 py-2 mr-auto btn__attach-file"
        @add-files="addFiles"
      />

      <b-button variant="primary" class="btn__submit-response btn__submit-message" @click="submit">
        Send
      </b-button>
    </div>

    <!-- attachment -->
    <BaseFilesList
      v-if="!message || message.isFileMessage"
      class="attachment__message mt-3"
      :attachments="attachments"
      enable-delete
      @delete-file="deleteFile"
    />
  </div>
</template>

<script>
import { BaseInput, BaseFilesList, BaseFilesUploadButton } from '@/components/base-components';
import { Channel, Message, User } from '@/models';

export default {
  name: 'ResponseBlock',

  components: { BaseInput, BaseFilesList, BaseFilesUploadButton },

  props: {
    isFooter: {
      type: Boolean,
      default: true
    },
    channelUrl: {
      type: String,
      default: ''
    },
    user: {
      type: User,
      default: null
    },
    message: {
      type: Message,
      default: null
    }
  },

  data() {
    return {
      description: this.message ? this.message.message : '',
      attachments: [],
      submitFail: false,
      isSaving: false,
      isEdit: false
    };
  },

  computed: {
    channel() {
      return Channel.findChannel(this.channelUrl);
    }
  },

  methods: {
    async submit() {
      if (!this.description && this.attachments.length == 0) {
        this.submitFail = true;
        return;
      }

      this.isSaving = true;
      try {
        if (this.description) {
          if (this.message) {
            const { messageId } = this.message;

            await this.channel.updateMessage(messageId, this.description);
          } else {
            await this.channel.sendMessage(this.description);
          }

          this.$toast.open({
            message: `Message has been ${this.message ? 'updated' : 'sent'} successfully`,
            type: 'success',
            pauseOnHover: true,
            duration: 5000
          });
        } else {
          this.submitFail = true;
        }
      } catch (error) {
        console.log(error);
        this.$toast.open({
          message: error,
          type: 'error',
          pauseOnHover: true,
          duration: 5000
        });
      }

      try {
        if (this.attachments.length) {
          if (this.message) {
            const { messageId } = this.message;

            await this.channel.updateFile(messageId, this.attachments[0]);
          } else {
            await this.channel.sendFiles(this.attachments);
          }

          this.$toast.open({
            message: `File has been ${this.message ? 'updated' : 'sent'} successfully`,
            type: 'success',
            pauseOnHover: true,
            duration: 5000
          });
        }

        // this.$emit("onActionMessageSuccess");
      } catch (error) {
        console.log(error);
        this.$toast.open({
          message: error,
          type: 'error',
          pauseOnHover: true,
          duration: 5000
        });
      }

      this.submitFail = false;
      this.isSaving = false;

      if (!this.message) {
        this.clear();
      }

      this.$emit('onActionMessageSuccess');
    },

    addFiles(files) {
      this.attachments = this.attachments.concat(files);
    },

    deleteFile(index) {
      this.attachments.splice(index, 1);
    },

    clear() {
      this.description = '';
      this.attachments = [];
    }
  }
};
</script>

<style lang="scss" scoped></style>
